import React, { ComponentType, useMemo } from 'react'
import PrizeBadge from '../ScopedBlock/PrizeBadge.svg?url'
import { Tabs } from '../Tabs/Tabs'
import { Spinner, Tab } from 'react-bootstrap'
import { Modal } from '../Modal/Modal'
import { InputParametersHierarchyInfo } from '../../views/Setup/AIFeaturePresets/PresetConfig/InputParametersHierarchyInfo'
import { useInputParametersConfig } from './hooks'
import { EmailTypeInputParametersHierarchyConfigComponentProps, InputParameterHierarchyType } from './model'

export interface EmailTypeInputParametersHierarchyConfigModalProps {
  show: boolean
  onHide: () => void
  type: InputParameterHierarchyType
  typeId: string
  name?: string
  emailTypeId: string
  inputParametersSchema: { [key: string]: any } | undefined
  defaultInputParameters: { [key: string]: any } | null
  EmailTypeConfig: ComponentType<EmailTypeInputParametersHierarchyConfigComponentProps>
  CurrentUserConfig: ComponentType<EmailTypeInputParametersHierarchyConfigComponentProps>
  TeamMembersConfig?: ComponentType<EmailTypeInputParametersHierarchyConfigComponentProps>
}

export const EmailTypeInputParametersHierarchyConfigModal: React.FC<EmailTypeInputParametersHierarchyConfigModalProps> = ({
  show,
  onHide,
  type,
  typeId,
  inputParametersSchema,
  defaultInputParameters,
  name,
  emailTypeId,
  EmailTypeConfig,
  CurrentUserConfig,
  TeamMembersConfig,
}) => {
  const { ipHierarchyEnabled, hasIpHierarchyAdminScope, showTabs, teamMembersLoading } = useInputParametersConfig()

  const configProps = useMemo(() => {
    return {
      type,
      typeId,
      inputParametersSchema,
      defaultInputParameters,
      emailTypeId,
      onHide,
      showCustomizationSetting: true,
      ipHierarchyEnabled,
    }
  }, [type, typeId, inputParametersSchema, defaultInputParameters, emailTypeId, onHide, ipHierarchyEnabled])

  const userTitle = (
    <div className='d-flex align-items-center'>
      {!ipHierarchyEnabled ? <img alt='Upgrade' src={PrizeBadge} /> : ''}
      Your Own
    </div>
  )

  const teamMembersTitle = (
    <div className='d-flex align-items-center'>
      {!ipHierarchyEnabled ? <img alt='Upgrade' src={PrizeBadge} /> : ''}
      Your Team Members
    </div>
  )

  const tabConfig = (
    <Tabs defaultActiveKey={hasIpHierarchyAdminScope ? 'global' : 'currentUser'} id='preset-config-tabs' className='d-flex mb-3' mountOnEnter unmountOnExit>
      <Tab eventKey='global' title='Email Type Level'>
        <InputParametersHierarchyInfo
          icon='bi-exclamation-square'
          message='These settings apply to everyone, unless they have their own settings for the email type.'
        />
        <EmailTypeConfig {...configProps} />
      </Tab>
      <Tab eventKey='currentUser' title={userTitle}>
        <InputParametersHierarchyInfo icon='bi-info-square' message='These settings will only apply to you for the email type. ' />
        <CurrentUserConfig {...configProps} />
      </Tab>
      {TeamMembersConfig && (
        <Tab eventKey='teamMembers' title={teamMembersTitle}>
          <InputParametersHierarchyInfo icon='bi-info-square' message='Manage settings for your team members for the email type. ' />
          <TeamMembersConfig {...configProps} />
        </Tab>
      )}
    </Tabs>
  )

  const singleConfig = ipHierarchyEnabled ? <CurrentUserConfig {...configProps} /> : <EmailTypeConfig {...configProps} />

  const body = (
    <>
      <h4 className='text-center mb-5'>{`Customize ${name} for email type`}</h4>
      {teamMembersLoading ? (
        <div className='d-flex align-items-center justify-content-center p-2'>
          <Spinner size={'sm'} />
        </div>
      ) : showTabs ? (
        tabConfig
      ) : (
        singleConfig
      )}
    </>
  )

  return <Modal size='lg' show={show} onHide={onHide} header={<></>} body={body} footer={<></>} />
}
